'use client'

export const ZIP_IP_PREFILL_FLAG = 'zip_ip_prefill_v1'

let ipZipRequest: Promise<string | null> | null = null

/**
 * Start (or join) the one IP-based ZIP lookup for this page load. Never
 * rejects: any failure resolves to null so callers can fire and forget.
 */
export function prefetchIpZip(): Promise<string | null> {
  if (!ipZipRequest) {
    ipZipRequest = fetch('/api/geo', { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { zip?: unknown } | null) =>
        typeof data?.zip === 'string' && /^\d{5}$/.test(data.zip) ? data.zip : null,
      )
      .catch(() => null)
  }
  return ipZipRequest
}

export function resetIpZipPrefetchForTests(): void {
  ipZipRequest = null
}
